<template>
  <modal :visible="visible" @close="close">
    <div class="box">
      <article class="media">
        <div class="media-content">
          <div class="heading">
            <h4>
              {{title}}
            </h4>
          </div>
          <div class="content">
            <button class="button is-primary" @click="$emit('confirm')">{{$t('common.yes')}}</button>
            <button class="button is-light" @click="$emit('close')">{{$t('common.no')}}</button>
          </div>
        </div>
      </article>
    </div>
  </modal>
</template>


<script>
  import { Modal } from 'vue-bulma-modal'
  import i18n from '../../translations/i18n'

  export default {
    components: {
      Modal
    },

    props: {
      visible: Boolean,
      title: String
    },

    methods: {
      close () {
        this.$emit('close')
      }
    },
    i18n: i18n
  }

</script>
<style>
  .modal {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
  }
  .modal .modal-body {
    text-align: center;
    padding-top: 20px;
    width: 300px;
    height: 100px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?d14d8afc